import { Middleware } from '@reduxjs/toolkit';

export const errorMiddleware: Middleware = ({ dispatch }) => (next) => (action) => {
  try {
    return next(action);
  } catch (err: any) {
    console.error('⚠️ Error crítico en Redux:', err);

    // Opcional: puedes hacer filtros por tipo de error
    const critical = err?.message?.includes('Cannot') || err?.message?.includes('undefined');

    if (critical) {
      // Ejecutar acción de reset general
      dispatch({ type: 'reset/resetState' });

      // Redirigir al login
      window.location.href = '/login';
    }

    throw err;
  }
};
